import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { campaignService } from "@/services";
import { apiErrorMessage } from "@/lib/api";
import { UserMinus, Loader2, CheckCircle2, AlertCircle } from "lucide-react";

export default function UnsubscribePage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    campaignService.optoutInfo(token)
      .then((d) => { setInfo(d); if (d.alreadyOptedOut) setDone(true); })
      .catch((e) => setError(apiErrorMessage(e.response?.data?.detail) || "Invalid or expired link"))
      .finally(() => setLoading(false));
  }, [token]);

  const submit = async () => {
    setSubmitting(true);
    try { await campaignService.optoutSubmit(token); setDone(true); }
    catch (e) { setError(apiErrorMessage(e.response?.data?.detail) || "Could not unsubscribe"); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="unsubscribe-page">
      <div className="w-full max-w-md bg-slate-900 rounded-2xl border border-slate-800 p-8 shadow-2xl text-center">
        <div className="inline-flex h-12 w-12 rounded-2xl bg-amber-500/15 text-amber-400 items-center justify-center mb-4"><UserMinus className="h-6 w-6" /></div>
        {loading ? (
          <Loader2 className="h-6 w-6 animate-spin text-slate-500 mx-auto my-8" />
        ) : error ? (
          <div data-testid="unsubscribe-error"><AlertCircle className="h-10 w-10 text-red-400 mx-auto mb-3" /><p className="text-slate-300">{error}</p></div>
        ) : done ? (
          <div data-testid="unsubscribe-done">
            <CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto mb-3" />
            <h1 className="text-xl font-bold text-white">You're unsubscribed</h1>
            <p className="text-slate-400 text-sm mt-1">You will no longer receive {info?.channel} campaigns from us.</p>
          </div>
        ) : (
          <div>
            <h1 className="text-xl font-bold text-white mb-2">Unsubscribe</h1>
            <p className="text-slate-400 text-sm mb-6">Hi {info?.customerName || "there"}, confirm you'd like to stop receiving {info?.channel} campaign messages?</p>
            <button onClick={submit} disabled={submitting} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold rounded-lg py-2.5 flex items-center justify-center gap-2 disabled:opacity-50 transition-colors" data-testid="unsubscribe-confirm">
              {submitting && <Loader2 className="h-4 w-4 animate-spin" />} Confirm unsubscribe
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
